export type AiCaptainChoiceSelectionMode = 'single' | 'multiple';

export interface AiCaptainChoiceOption {
  id: string;
  label: string;
  value: string;
}

export interface AiCaptainChoicePrompt {
  promptId: string;
  prompt: string;
  speakText?: string;
  selectionMode: AiCaptainChoiceSelectionMode;
  options: AiCaptainChoiceOption[];
  minSelections?: number;
  maxSelections?: number;
}

export function normalizeAiCaptainChoicePrompt(
  raw: Record<string, unknown>
): AiCaptainChoicePrompt | null {
  const prompt = raw.prompt != null ? String(raw.prompt).trim() : '';
  const promptId = raw.promptId != null ? String(raw.promptId) : '';
  const selectionMode = raw.selectionMode === 'multiple' ? 'multiple' : 'single';
  const optionsRaw = Array.isArray(raw.options) ? raw.options : [];
  const options: AiCaptainChoiceOption[] = optionsRaw
    .map((entry, index) => {
      if (!entry || typeof entry !== 'object') return null;
      const row = entry as Record<string, unknown>;
      const label = row.label != null ? String(row.label).trim() : '';
      if (!label) return null;
      const id = row.id != null ? String(row.id).trim() : `opt-${index + 1}`;
      const value = row.value != null ? String(row.value).trim() : label;
      return { id, label, value };
    })
    .filter((opt): opt is AiCaptainChoiceOption => opt != null);

  if (!prompt || options.length === 0) return null;

  return {
    promptId: promptId || `choice-${Date.now()}`,
    prompt,
    speakText: raw.speakText != null ? String(raw.speakText).trim() : undefined,
    selectionMode,
    options,
    minSelections:
      raw.minSelections != null && Number.isFinite(Number(raw.minSelections))
        ? Math.max(1, Math.floor(Number(raw.minSelections)))
        : undefined,
    maxSelections:
      raw.maxSelections != null && Number.isFinite(Number(raw.maxSelections))
        ? Math.max(1, Math.floor(Number(raw.maxSelections)))
        : undefined,
  };
}
